import script from "./WidgetMediaViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./WidgetMediaViewer.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__